export default __webpack_public_path__ + "assets/portraits.6a7816d3e254260bc800a8a1c2bb079d.jpg";